import React, { useEffect } from 'react';
import { Link, NavLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import LogoSvg from '../assets/images/CaeserTechStudio.svg';

const Header = () => {
  const { t } = useTranslation();

  // 處理導航項點擊事件，關閉選單
  const handleNavItemClick = () => {
    // 只有在小螢幕模式下才需要關閉選單
    if (window.innerWidth < 992) {
      // 獲取導航選單
      const navbarCollapse = document.getElementById('navbarNav');
      // 如果選單是展開狀態，則點擊選單按鈕關閉它
      if (navbarCollapse && navbarCollapse.classList.contains('show')) {
        document.querySelector('.navbar-toggler').click();
      }
    }
  };

  return (
    <nav className="navbar navbar-expand-lg navbar-dark bg-dark fixed-top">
      <div className="container">
        <Link className="navbar-brand d-flex align-items-center" to="/">
          <img 
            src={LogoSvg} 
            alt="CaesarTechStudio Logo" 
            height="30" 
            className="mr-2" 
          />
          <span style={{ 
            fontWeight: 700, 
            fontSize: '1.5rem', 
            color: '#fff',
            padding: '5px 10px',
            borderRadius: '4px'
          }}>
            Caesar<span style={{ fontWeight: 500 }}>Tech</span>Studio
          </span>
        </Link>
        <button 
          className="navbar-toggler" 
          type="button" 
          data-bs-toggle="collapse" 
          data-bs-target="#navbarNav" 
          aria-controls="navbarNav" 
          aria-expanded="false" 
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>
        <div className="collapse navbar-collapse justify-content-end" id="navbarNav">
          <ul className="navbar-nav">
            <li className="nav-item">
              <NavLink 
                className={({ isActive }) => isActive ? "nav-link active" : "nav-link"} 
                to="/"
                onClick={handleNavItemClick}
              >
                {t('home')}
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink 
                className={({ isActive }) => isActive ? "nav-link active" : "nav-link"} 
                to="/about"
                onClick={handleNavItemClick}
              >
                {t('about')}
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink 
                className={({ isActive }) => isActive ? "nav-link active" : "nav-link"} 
                to="/services"
                onClick={handleNavItemClick}
              >
                {t('ourServices')}
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink 
                className={({ isActive }) => isActive ? "nav-link active" : "nav-link"} 
                to="/portfolio"
                onClick={handleNavItemClick}
              >
                {t('portfolio')}
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink 
                className={({ isActive }) => isActive ? "nav-link active" : "nav-link"} 
                to="/contact"
                onClick={handleNavItemClick}
              >
                {t('contact')}
              </NavLink>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
};

export default Header; 